import * as React from 'react';
import { SVGProps } from 'react';

const IconTranslateSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 11H9.908l-.611-1.5H6.703L6.092 11H5l2.457-6h1.092L11 11ZM6.948 8.5h1.939L8 6 6.948 8.5Z"
    />
    <path d="M7 4H6l-.758 1.707-1.414 1.414 1.414 1.414-.707.708L3.12 7.828 1.707 9.242 1 8.535l1.413-1.414L1 5.707 1.707 5l1.414 1.414L4.535 5 5 4H1V3h6v1ZM5 2H3V1h2v1Z" />
  </svg>
);
export default IconTranslateSizeXs;
